import type { IconColor, Icons } from '@ksyos/design-system';
import { Icon, Text } from '@ksyos/design-system';
import classnames from 'classnames';
import type { ProcessStatusLabelData } from '@common/interfaces/processes';
import { never } from '@common/utils/never';
import { getProcessTaskStatusLabel, ProcessTaskStatusRelation } from './processTaskStatus';
import { getServiceActivityClosedLabel } from './serviceActivityClosedLabel';

interface IProcessStatusLabelAndIcon {
    color?: IconColor;
    icon: Icons;
    label: string;
}

export function ProcessStatusLabel(props: ProcessStatusLabelData) {
    const { color, icon, label } = getProcessStatusLabelAndIcon(props);

    return (
        <span className={classnames('status-label')}>
            <Icon
                color={color}
                icon={icon}
                sx={{ mr: 2 }}
            />
            <Text
                as="span"
                color={color}
                fontWeight="bold"
                size="xs"
                whiteSpace="nowrap"
            >
                {label}
            </Text>
        </span>
    );
}

function getProcessStatusLabelAndIcon(data: ProcessStatusLabelData): IProcessStatusLabelAndIcon {
    switch (data.type) {
        case 'taskPerformer':
            return {
                color: 'secondary',
                icon: 'todo',
                label: getProcessTaskStatusLabel(data.label, ProcessTaskStatusRelation.performer, data.status),
            };
        case 'taskRequester':
            return {
                icon: 'waiting',
                label: getProcessTaskStatusLabel(data.label, ProcessTaskStatusRelation.requester),
            };
        case 'admin':
            return {
                icon: 'waiting',
                label: getProcessTaskStatusLabel(data.label, ProcessTaskStatusRelation.admin),
            };
        case 'fixedValue':
            if (data.label === 'closed') {
                return { icon: 'closed', label: 'Gesloten' };
            }
            if (data.label === 'ongoing') {
                return { icon: 'waiting', label: 'In behandeling' };
            }
            if (data.label === 'withColleague') {
                return { icon: 'waiting', label: 'Bij collega' };
            }

            return { icon: 'closed', label: 'Onbekende status' };
        case 'closedActivity':
            return { icon: 'closed', label: getServiceActivityClosedLabel(data.label) };
        default:
            never(data);
    }
}
